<template>
    <section style="margin-top: 30px; margin-bottom: 100px;">
        <div class="container mt-4">

            <div class="row justify-content-center">
                <div class="col-md-6 col-sm-12 mb-4">
                    <div class="p-4 rounded text-center border">
                        <span style="font-weight: 600; color: black;">Edit SHipment {{ this.$route.params.shipment_id }}</span>
                        <form @submit.prevent="ShowSignupAlert" style="margin-top: 20px;">
                            

                        <div class="form-group mb-3">
                            <div class="row">
                                <div class="col">
                                    <label class="label-control" style="color: black; font-weight: 600; margin-bottom: 5px;">Shipping date</label>
                                    <input type="text" class="form-control" placeholder="Shipping date" required v-model="shipment.shipping_date">
                                </div>
                                <div class="col">
                                    <label class="label-control" style="color: black; font-weight: 600; margin-bottom: 5px;">Delivery date</label>
                                    <input type="text" class="form-control" placeholder="Delivery date" required v-model="shipment.delivery_date">
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <div class="row">
                                <div class="col">
                                    <label class="label-control" style="color: black; font-weight: 600; margin-bottom: 5px;">Transporter</label>
                                    <select class="form-select" v-model="shipment.transporter">
  <option value="FEDEX">FEDEX</option>
  <option value="UPS">UPS</option>
  <option value="TNT">TNT</option>
  <option value="TNT">CIT</option>
</select>
                                </div>
                                <div class="col">
                                    <label class="label-control" style="color: black; font-weight: 600; margin-bottom: 5px;">Tracking number</label>
                                    <input type="text" class="form-control" placeholder="Tracking number" required v-model="shipment.tracking_number">
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-3">
                            <button type="submit" class="btn btn-login2 me-2">Modify</button>
                            <br>
                            <div class="notification is-danger" v-if="errors.length">
                                <p v-for="error in errors" :key="error">{{ error }}</p>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import axios from 'axios'
import { toast } from 'bulma-toast'
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import Swal from 'sweetalert2'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';


export default {
    name: 'SignUp',
    mixins: [en, fr, nl],
    data() {
        return {
            shipment : {},
            errors: []
        }
    },
    computed: {
        lang(){
      return this.$store.state.lang
    },
},
    async mounted() {
        document.title = 'Edit shipment | Eurekali'

        await axios.get(`/api/v1/admin/get-shipment-details/${this.$route.params.shipment_id}/`)
      .then(response => {
        this.shipment = response.data


      })
      .catch(error => {
        console.log(error)
      })
    },
    methods: {
        translate(prop){
      return this[this.lang][prop]; 
    },
    ShowSignupAlert() {
      Swal.fire({
        icon: 'question',
        title: 'Edit shipment',
        text: 'Are you sure you want to modify this shipment ?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#4BB543',
        cancelButtonColor: '#ff0e0e',
      }).then((result) => {
        if (result.isConfirmed) {
            this.editShipment();
        }
      });
    },
    async editShipment() {
            const formData = {
                shipping_date: this.shipment.shipping_date,
                delivery_date: this.shipment.delivery_date,
                transporter: this.shipment.transporter,
                tracking_number: this.shipment.tracking_number,
            }
            this.$store.commit('setIsLoading', true)
            await axios
                .post(`/api/v1/admin/edit-shipment-details/${this.$route.params.shipment_id}/`, formData)
                .then(response => {
                    
                    const toPath = this.$route.query.to || '/shipments-progress'
                    this.$router.push(toPath)
                })
                .catch(error => {
                    if (error.response) {
                        this.errors.push(this.translate('login_error'))
                    } else {
                        this.errors.push('Something went wrong. Please try again')

                        console.log(JSON.stringify(error))
                    }
                })
                this.$store.commit('setIsLoading', false)
        }
    }
}
</script>

<style>

.btn-login2{
    background-color: #E5097F;
    color: white;
    margin-left: 15px;
    border-radius: 20px;
    font-weight: bold;
    padding-left: 25px;
    padding-right: 25px;
}

.btn-login2:hover{
    background-color: #9b0656;
    color: white;
}
</style>